import { render } from "./Templates.vue?vue&type=template&id=73f19cc8&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=ts"
export * from "./Templates.vue?vue&type=script&lang=ts"

import "./Templates.vue?vue&type=style&index=0&id=73f19cc8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73f19cc8"

export default script